import React, { Component } from 'react';
import { Field } from 'redux-form';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchDropdown } from '../../../actions/actionCreators';

import {
  renderSearchMultipleDropdown,
  renderSearchDropDown,
} from '../../common/form/FieldHelper';

class SupplierDropdown extends Component {
  render() {
    const { name, form, searchFn, onPostChange, multiple, excludedSuppliers } =
      this.props;

    return (
      <div className="field">
        <Field
          {...this.props}
          name={name}
          formId={form}
          searchFn={searchFn}
          dropdownType="supplier"
          type="supplier"
          component={
            multiple ? renderSearchMultipleDropdown : renderSearchDropDown
          }
          onPostChange={onPostChange}
          valueField="id"
          searchParams={{
            excluded_entities: excludedSuppliers,
          }}
        />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      searchFn: fetchDropdown,
    },
    dispatch
  );
}

export default connect(null, mapDispatchToProps)(SupplierDropdown);
